//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table
  },
  mounted: function() {
    this.columns = [
      {
        name: "code",
        required: false,
        label: "Código",
        align: "left",
        field: row => row.code,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "name",
        required: false,
        align: "left",
        label: "Nome de Armazém",
        field: row => row.name,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "storage_type",
        required: false,
        align: "left",
        label: "Tipo",
        field: row => row.storage_type.name,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "distrito",
        required: false,
        align: "left",
        label: "Distrito",
        field: (row) => (row.geography[0].name),
        sortable: false,
      },
      {
        name: "concelho",
        required: false,
        align: "left",
        label: "Concelho",
        field: (row) => (row.geography[1].name),
        sortable: false,
      },
      {
        name: "freguesia",
        required: false,
        align: "left",
        label: "Freguesia",
        field: (row) => (row.geography[2].name),
        sortable: false,
      },
      {
        name: "address",
        required: false,
        align: "left",
        label: "Morada",
        field: row => row.address,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "postal_code",
        required: false,
        align: "left",
        label: "Código Postal",
        field: row => row.postal_code,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "locality",
        required: false,
        align: "left",
        label: "Localidade",
        field: row => row.locality,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "latitude",
        required: false,
        align: "left",
        label: "Latitude",
        field: row => row.latitude,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "longitude",
        required: false,
        align: "left",
        label: "Longitude",
        field: row => row.longitude,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "pickup-location",
        required: false,
        align: "left",
        label: "Local de recolha",
        field: row => row.pickup_address,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "dropoff-location",
        required: false,
        align: "left",
        label: "Local de entrega",
        field: row => row.dropoff_address,
        format: DEFAULT_FORMAT,
        sortable: false
      }
    ];
  },
  data: () => ({
    separator: "horizontal",
    columns: [],
    filteredData: []
  }),
  methods: {
    renderRightSide: function(event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function(event) {
      this.$emit("filter-changed", event);
    }
  }
};
